module.exports = __webpack_public_path__ + "img/tarj2-4.01c3496d.png";